import axios from 'axios';
import { getAppContext } from '../config/appContext';

function getPublicApiUrl() {
  const ctx = getAppContext();
  const origin = ctx.apiBaseUrl.replace(/\/api\/platform$/, '');
  return `${origin}/api/public`;
}

export const DEFAULT_PLANS = [
  {
    id: 2,
    name: 'Profesional',
    slug: 'profesional',
    max_inmuebles: 2,
    max_usuarios: 6,
    max_storage_mb: 10240,
    price_monthly: '59.00',
  },
  {
    id: 3,
    name: 'Enterprise',
    slug: 'enterprise',
    max_inmuebles: 5,
    max_usuarios: 15,
    max_storage_mb: 51200,
    price_monthly: '149.00',
  },
];

const publicPlanService = {
  async fetchPlans() {
    const { data } = await axios.get(`${getPublicApiUrl()}/plans`, {
      timeout: 10000,
      headers: { Accept: 'application/json' },
    });
    return data.plans?.length
      ? data.plans.filter((p) => p.slug !== 'starter')
      : DEFAULT_PLANS;
  },
};

export default publicPlanService;
